import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, vModelRadio as _vModelRadio, vModelCheckbox as _vModelCheckbox, vModelSelect as _vModelSelect, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = {
  key: 0,
  class: "bg-red-50 border border-red-200 rounded-lg p-4 text-red-700"
}
const _hoisted_3 = ["onSubmit"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "title",
  class: "block text-sm font-medium text-primary-700 mb-1"
}, " Title ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "description",
  class: "block text-sm font-medium text-primary-700 mb-1"
}, " Description ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-primary-700 mb-1" }, " Vote Type ", -1)
const _hoisted_7 = { class: "flex gap-4" }
const _hoisted_8 = { class: "flex items-center gap-2 cursor-pointer" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Yes/No", -1)
const _hoisted_10 = { class: "flex items-center gap-2 cursor-pointer" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Multiple Choice", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  for: "required_response",
  class: "block text-sm font-medium text-primary-700 mb-1"
}, " Required Response (%) ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-primary-500 mt-1" }, " Percentage of households that must vote for the vote to be valid ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  for: "deadline",
  class: "block text-sm font-medium text-primary-700 mb-1"
}, " Voting Deadline ", -1)
const _hoisted_15 = { class: "flex items-center gap-3" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  for: "anonymous",
  class: "text-sm font-medium text-primary-700"
}, " Anonymous voting (hide who voted for what) ", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-primary-700 mb-1" }, " Status ", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("option", { value: "draft" }, "Draft (not visible to users)", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("option", { value: "active" }, "Active (open for voting)", -1)
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = {
  key: 0,
  class: "bg-red-50 border border-red-200 rounded-lg p-4 text-red-700"
}
const _hoisted_22 = {
  key: 1,
  class: "bg-green-50 border border-green-200 rounded-lg p-4 text-green-700"
}
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }

import { ref, computed, reactive } from "vue";
import { useAuthStore } from "@/stores/auth";
import { useVoteStore } from "@/stores/votes";
import Datepicker from "vue3-datepicker";
import TipTapEditorVue from "./TipTapEditor.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const authStore = useAuthStore();
const voteStore = useVoteStore();

const loading = ref(false);
const error = ref("");
const success = ref(false);

const minDate = new Date();
minDate.setDate(minDate.getDate() + 1);

const form = reactive({
  title: "",
  description: "",
  vote_type: "yes_no",
  required_response: 51,
  response_deadline: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000), // 1 week from now
  anonymous: true,
  status: "draft",
});

const isAdmin = computed(() => authStore.is_staff);

const isFormValid = computed(() => {
  return (
    form.title.trim() !== "" &&
    form.description.trim() !== "" &&
    form.required_response >= 1 &&
    form.required_response <= 100 &&
    form.response_deadline
  );
});

const handleSubmit = async () => {
  if (!isFormValid.value || !isAdmin.value) return;

  loading.value = true;
  error.value = "";
  success.value = false;

  try {
    const voteData = {
      title: form.title,
      description: form.description,
      vote_type: form.vote_type,
      required_response: form.required_response,
      response_deadline: form.response_deadline.toISOString(),
      anonymous: form.anonymous,
      status: form.status,
    };

    await voteStore.create_vote(voteData);
    success.value = true;

    // Reset form
    form.title = "";
    form.description = "";
    form.vote_type = "yes_no";
    form.required_response = 51;
    form.response_deadline = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000);
    form.anonymous = true;
    form.status = "draft";
  } catch (e: any) {
    error.value =
      e?.response?.data?.error || "Failed to create vote. Please try again.";
  } finally {
    loading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(isAdmin))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Only administrators can create votes. "))
      : (_openBlock(), _createElementBlock("form", {
          key: 1,
          onSubmit: _withModifiers(handleSubmit, ["prevent"]),
          class: "space-y-4"
        }, [
          _createElementVNode("div", null, [
            _hoisted_4,
            _withDirectives(_createElementVNode("input", {
              id: "title",
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).title) = $event)),
              required: "",
              class: "w-full px-4 py-3 border border-primary-200 rounded-lg focus:ring-2 focus:ring-accent-500 focus:border-accent-500",
              placeholder: "Enter vote title"
            }, null, 512), [
              [_vModelText, _unref(form).title]
            ])
          ]),
          _createElementVNode("div", null, [
            _hoisted_5,
            _createVNode(TipTapEditorVue, {
              modelValue: _unref(form).description,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).description) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", null, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).vote_type) = $event)),
                  value: "yes_no",
                  class: "text-accent-600 focus:ring-accent-500"
                }, null, 512), [
                  [_vModelRadio, _unref(form).vote_type]
                ]),
                _hoisted_9
              ]),
              _createElementVNode("label", _hoisted_10, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).vote_type) = $event)),
                  value: "multiple_choice",
                  class: "text-accent-600 focus:ring-accent-500"
                }, null, 512), [
                  [_vModelRadio, _unref(form).vote_type]
                ]),
                _hoisted_11
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _hoisted_12,
            _withDirectives(_createElementVNode("input", {
              id: "required_response",
              type: "number",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).required_response) = $event)),
              min: "1",
              max: "100",
              required: "",
              class: "w-full px-4 py-3 border border-primary-200 rounded-lg focus:ring-2 focus:ring-accent-500 focus:border-accent-500"
            }, null, 512), [
              [
                _vModelText,
                _unref(form).required_response,
                void 0,
                { number: true }
              ]
            ]),
            _hoisted_13
          ]),
          _createElementVNode("div", null, [
            _hoisted_14,
            _createVNode(_unref(Datepicker), {
              modelValue: _unref(form).response_deadline,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).response_deadline) = $event)),
              class: "w-full",
              "lower-limit": _unref(minDate)
            }, null, 8, ["modelValue", "lower-limit"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _withDirectives(_createElementVNode("input", {
              id: "anonymous",
              type: "checkbox",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).anonymous) = $event)),
              class: "w-5 h-5 text-accent-600 border-primary-300 rounded focus:ring-accent-500"
            }, null, 512), [
              [_vModelCheckbox, _unref(form).anonymous]
            ]),
            _hoisted_16
          ]),
          _createElementVNode("div", null, [
            _hoisted_17,
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(form).status) = $event)),
              class: "w-full px-4 py-3 border border-primary-200 rounded-lg focus:ring-2 focus:ring-accent-500 focus:border-accent-500"
            }, _hoisted_20, 512), [
              [_vModelSelect, _unref(form).status]
            ])
          ]),
          (error.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(error.value), 1))
            : _createCommentVNode("", true),
          (success.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, " Vote created successfully! "))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "submit",
            disabled: loading.value || !_unref(isFormValid),
            class: _normalizeClass(["w-full py-3 px-6 font-medium text-white rounded-lg transition-all duration-200", 
          loading.value || !_unref(isFormValid)
            ? 'bg-gray-300 cursor-not-allowed'
            : 'bg-accent-700 hover:bg-accent-800 active:scale-98'
        ])
          }, [
            (loading.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_24, "Creating Vote..."))
              : (_openBlock(), _createElementBlock("span", _hoisted_25, "Create Vote"))
          ], 10, _hoisted_23)
        ], 40, _hoisted_3))
  ]))
}
}

})